<template>
    <v-container grid-list-md fluid>
        <v-row v-if="!hideOptions">
            <v-col>
                <v-radio-group
                    v-model="generalLedgerDisplay"
                    inline
                    class="text-center"
                    color="primary"
                >
                    <v-radio label="Grand Livre" value="generalLedger" />
                    <v-radio label="Balance" value="balance" />
                </v-radio-group>
            </v-col>
            <v-col>
                <v-switch v-model="localThirdParty" :label="'Compte Auxiliaire'" class="ml-2" />
            </v-col>
        </v-row>
        <!-- <v-radio label="Balance" value="balance"></v-radio> -->
        <v-data-table
            :hide-default-header="generalLedgerExpanded.length > 0"
            :headers="generalLedgerHeaders"
            :items="generalLedger"
            :items-per-page="-1"
            hide-default-footer
            class="table"
        >
            <!-- <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>Grand Livre</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-switch v-model="singleExpand" label="Single expand" class="mt-2"></v-switch>
            </v-toolbar>
            </template> -->

            <!-- // ** icon + title -->
            <template v-slot:item="props">
                <!-- // ** titles -->
                <tr
                    style="background-color: #e1e1e1"
                    :key="props.item.key"
                    @click="addRemoveGeneralLedgerExpanded(props.item)"
                >
                    <!-- // ** commons titles -->
                    <td class="text-center">
                        <v-icon>{{
                            isGeneralLedgerExpanded(props.item)
                                ? "$fa-chevron-down"
                                : "$fa-chevron-up"
                        }}</v-icon>
                    </td>

                    <td colspan="4" class="text-left" :style="mainColor(props.item)">
                        <strong>{{ mainTitle(props.item) }}</strong>
                        <v-icon
                            v-if="containsErrors(props.item)"
                            color="error"
                            class="pl-2"
                            size="small"
                            >$fa-exclamation-triangle</v-icon
                        >
                    </td>

                    <!-- // ** generalLedger titles -->
                    <template v-if="isGeneralLedgerExpanded(props.item)">
                        <td class="text-right"><strong>Débit</strong></td>
                        <td class="text-right"><strong>Crédit</strong></td>
                        <td class="text-center" colspan="1"><strong>Lettrage</strong></td>
                        <td class="text-right"><strong>Solde</strong></td>
                    </template>

                    <!-- // ** balance titles -->
                    <template v-else>
                        <td class="text-right">
                            <strong>{{
                                props.item.totalDebit != 0.0
                                    ? newCommonFormatCurrency(props.item.totalDebit, undefined)
                                    : "-"
                            }}</strong>
                        </td>
                        <td class="text-right">
                            <strong>{{
                                props.item.totalCredit != 0.0
                                    ? newCommonFormatCurrency(props.item.totalCredit, undefined)
                                    : "-"
                            }}</strong>
                        </td>
                        <td colspan="1" />
                        <td class="text-right">
                            <strong>{{
                                props.item.totalDebit - props.item.totalCredit
                                    ? newCommonFormatCurrency(
                                          props.item.totalDebit - props.item.totalCredit,
                                          undefined,
                                      )
                                    : "-"
                            }}</strong>
                        </td>
                    </template>
                </tr>

                <!-- // ** generalLedger -->
                <template v-if="isGeneralLedgerExpanded(props.item)">
                    <tr
                        v-for="(accountingTransaction, i) in props.item.accountingTransactions"
                        :key="props.item.key + i"
                        @click="openAccountingTransaction(accountingTransaction)"
                        :style="accountingTransactionStyle(accountingTransaction)"
                    >
                        <td>{{ $t("accountingItem.type." + accountingTransaction.log) }}</td>
                        <td>{{ formatDate(accountingTransaction.date) }}</td>
                        <td>{{ accountingTransaction.wording }}</td>
                        <td>{{ accountingTransaction.number }}</td>
                        <td>{{ accountingTransaction.invoiceNumber }}</td>
                        <td class="text-right">
                            {{
                                accountingTransaction.debit
                                    ? newCommonFormatCurrency(
                                          accountingTransaction.debit,
                                          undefined,
                                      )
                                    : "-"
                            }}
                        </td>
                        <td class="text-right">
                            {{
                                accountingTransaction.credit
                                    ? newCommonFormatCurrency(
                                          accountingTransaction.credit,
                                          undefined,
                                      )
                                    : "-"
                            }}
                        </td>
                        <td class="text-center" colspan="1">
                            {{ accountingTransaction.lettering || "" }}
                        </td>
                        <td class="text-right">
                            {{
                                accountingTransaction.balance
                                    ? newCommonFormatCurrency(
                                          accountingTransaction.balance,
                                          undefined,
                                      )
                                    : "-"
                            }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="1" />
                        <td class="text-center" colspan="3">
                            <div style="color: red" v-if="props.item.error">
                                {{ props.item.error }}
                            </div>
                        </td>
                        <td class="text-right" colspan="1"><strong>Soldes</strong></td>
                        <td class="text-right">
                            <strong>{{
                                props.item.totalDebit != 0.0
                                    ? newCommonFormatCurrency(props.item.totalDebit, undefined)
                                    : "-"
                            }}</strong>
                        </td>
                        <td class="text-right">
                            <strong>{{
                                props.item.totalCredit != 0.0
                                    ? newCommonFormatCurrency(props.item.totalCredit, undefined)
                                    : "-"
                            }}</strong>
                        </td>
                        <td colspan="1" />
                        <td class="text-right">
                            <strong>{{
                                props.item.totalDebit - props.item.totalCredit
                                    ? newCommonFormatCurrency(
                                          props.item.totalDebit - props.item.totalCredit,
                                          undefined,
                                      )
                                    : "-"
                            }}</strong>
                        </td>
                    </tr>
                </template>
            </template>

            <!-- // ** footers -->
            <template v-slot:body.append>
                <template v-if="generalLedger.length > 0">
                    <template v-if="!localThirdParty">
                        <!-- <tr v-show="generalLedgerExpanded.length === 0" > -->
                        <tr>
                            <td class="text-right" colspan="5">Balance</td>
                            <td class="text-right">
                                <strong>{{
                                    newCommonFormatCurrency(totalDebit, undefined)
                                }}</strong>
                            </td>
                            <td class="text-right">
                                <strong>{{
                                    newCommonFormatCurrency(totalCredit, undefined)
                                }}</strong>
                            </td>
                            <td />
                            <td class="text-right" :style="totalBalance ? 'color:red;' : ''">
                                <strong>{{
                                    totalBalance
                                        ? newCommonFormatCurrency(totalBalance, undefined)
                                        : "-"
                                }}</strong>
                            </td>
                        </tr>
                        <!-- <tr v-show="generalLedgerExpanded.length === 0"> -->
                        <tr v-if="!hideBodyAppend">
                            <td class="text-right" colspan="5">Total charges</td>
                            <td class="text-right">
                                <strong>{{
                                    total6Debit - total6Credit
                                        ? newCommonFormatCurrency(total6Debit - total6Credit)
                                        : "-"
                                }}</strong>
                            </td>
                            <td class="text-right">
                                <!-- <strong>{{
                                    newCommonFormatCurrency(total6Credit, undefined)
                                }}</strong> -->
                            </td>
                            <td />
                            <td class="text-right" />
                        </tr>

                        <!-- <tr v-show="generalLedgerExpanded.length === 0"> -->
                        <tr v-if="!hideBodyAppend">
                            <td class="text-right" colspan="5">Total produits</td>
                            <td class="text-right">
                                <!-- <strong>{{
                                    newCommonFormatCurrency(total7Debit, undefined)
                                }}</strong> -->
                            </td>
                            <td class="text-right">
                                <strong>{{
                                    total7Credit - total7Debit
                                        ? newCommonFormatCurrency(total7Credit - total7Debit)
                                        : "-"
                                }}</strong>
                            </td>
                            <td />
                            <td class="text-right" />
                        </tr>

                        <!-- <tr v-show="generalLedgerExpanded.length === 0"> -->
                        <tr v-if="!hideBodyAppend">
                            <td class="text-right" colspan="5">
                                {{ profitOrLoss > 0 ? "Bénéfice" : "Perte" }}
                            </td>
                            <td class="text-right" />
                            <td class="text-right" />
                            <td />
                            <td class="text-right">
                                <strong>{{
                                    profitOrLoss
                                        ? newCommonFormatCurrency(Math.abs(profitOrLoss))
                                        : "-"
                                }}</strong>
                            </td>
                        </tr>
                    </template>

                    <template v-else>
                        <!-- // ** 401 -->
                        <!-- <tr v-show="generalLedgerExpanded.length === 0"> -->
                        <tr>
                            <td class="text-right" colspan="5">Total 401</td>
                            <td class="text-right">
                                <strong>{{
                                    total401Debit != 0.0
                                        ? newCommonFormatCurrency(total401Debit, undefined)
                                        : "-"
                                }}</strong>
                            </td>
                            <td class="text-right">
                                <strong>{{
                                    total401Credit != 0.0
                                        ? newCommonFormatCurrency(total401Credit, undefined)
                                        : "-"
                                }}</strong>
                            </td>
                            <td />
                            <td class="text-right">
                                <strong>{{
                                    total401Debit - total401Credit
                                        ? newCommonFormatCurrency(
                                              total401Debit - total401Credit,
                                              undefined,
                                          )
                                        : "-"
                                }}</strong>
                            </td>
                        </tr>

                        <!-- // ** 411 -->
                        <!-- <tr v-show="generalLedgerExpanded.length === 0"> -->
                        <tr>
                            <td class="text-right" colspan="5">Total 411</td>
                            <td class="text-right">
                                <strong>{{
                                    total411Debit != 0.0
                                        ? newCommonFormatCurrency(total411Debit, undefined)
                                        : "-"
                                }}</strong>
                            </td>
                            <td class="text-right">
                                <strong>{{
                                    total411Credit != 0.0
                                        ? newCommonFormatCurrency(total411Credit, undefined)
                                        : "-"
                                }}</strong>
                            </td>
                            <td />
                            <td class="text-right">
                                <strong>{{
                                    total411Debit - total411Credit
                                        ? newCommonFormatCurrency(
                                              total411Debit - total411Credit,
                                              undefined,
                                          )
                                        : "-"
                                }}</strong>
                            </td>
                        </tr>

                        <!-- // ** 42 -->
                        <!-- <tr v-show="generalLedgerExpanded.length === 0"> -->
                        <tr>
                            <td class="text-right" colspan="5">Total 42</td>
                            <td class="text-right">
                                <strong>{{
                                    total42Debit != 0.0
                                        ? newCommonFormatCurrency(total42Debit, undefined)
                                        : "-"
                                }}</strong>
                            </td>
                            <td class="text-right">
                                <strong>{{
                                    total42Credit != 0.0
                                        ? newCommonFormatCurrency(total42Credit, undefined)
                                        : "-"
                                }}</strong>
                            </td>
                            <td />
                            <td class="text-right">
                                <strong>{{
                                    total42Debit - total42Credit
                                        ? newCommonFormatCurrency(
                                              total42Debit - total42Credit,
                                              undefined,
                                          )
                                        : "-"
                                }}</strong>
                            </td>
                        </tr>

                        <!-- // ** 512 -->
                        <!-- <tr v-show="generalLedgerExpanded.length === 0"> -->
                        <tr>
                            <td class="text-right" colspan="5">Total 512</td>
                            <td class="text-right">
                                <strong>{{
                                    total512Debit != 0.0
                                        ? newCommonFormatCurrency(total512Debit, undefined)
                                        : "-"
                                }}</strong>
                            </td>
                            <td class="text-right">
                                <strong>{{
                                    total512Credit != 0.0
                                        ? newCommonFormatCurrency(total512Credit, undefined)
                                        : "-"
                                }}</strong>
                            </td>
                            <td />
                            <td class="text-right">
                                <strong>{{
                                    total512Debit - total512Credit
                                        ? newCommonFormatCurrency(
                                              total512Debit - total512Credit,
                                              undefined,
                                          )
                                        : "-"
                                }}</strong>
                            </td>
                        </tr>
                    </template>
                </template>
            </template>
        </v-data-table>
    </v-container>
</template>

<script lang="ts">
import colors from "vuetify/lib/util/colors";
import moment from "moment-timezone";

import { newCommonFormatCurrency } from "../../../backend/src/common/services/mathServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    emits: ["thirdPartyChanged"],
})
export class GeneralLedger extends Vue {
    @Prop({ default: [] }) generalLedger: any[];
    @Prop({ default: false }) thirdParty: boolean;
    @Prop({ default: undefined }) accountableAccountFilter: any;
    @Prop({ default: undefined }) excludedAccountableAccountFilter: any; // ex ["20", "21", "22", "23", "28", "145"]
    // @Prop({ default: "" }) thirdPartyType: string
    @Prop({ default: false }) hideOptions: boolean;
    @Prop({ default: false }) hideMiscellaneousOperationsBtn: boolean;
    @Prop({ default: false }) hideThirdPartySwitch: boolean;
    @Prop({ default: false }) hideBodyAppend: boolean;

    headers = [];

    date: String = "";

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    formatDate(date) {
        if (!date) return "";
        // moment.locale("fr");
        return moment(date, "YYYYMMDD").format("DD/MM/YYYY");
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }
    //
    // generalLedger
    //
    generalLedgerHeaders = [
        { title: "", value: "" },
        { title: "Compte comptable", value: "", align: "left", sortable: false },
        { title: "", value: "", sortable: false },
        { title: "", value: "", sortable: false },
        { title: "", value: "", sortable: false },
        { title: "Débit", value: "", align: "right", sortable: false },
        { title: "Crédit", value: "", align: "right", sortable: false },
        { title: "", value: "", sortable: false },
        { title: "Solde", value: "", align: "right", sortable: false },
    ];

    generalLedgerExpanded = [];

    get localThirdParty() {
        return this.thirdParty;
    }

    set localThirdParty(value) {
        if (this.thirdParty !== value) {
            this.$emit("thirdPartyChanged", value);
        }
    }

    @Watch("generalLedger")
    onGeneralLedger(value) {
        if (this.generalLedgerExpanded.length) {
            this.generalLedgerExpanded.splice(0, this.generalLedgerExpanded.length);
            this.generalLedgerExpanded.push(this.generalLedger);
        } else {
            this.generalLedgerExpanded.splice(0, this.generalLedgerExpanded.length);
        }
    }

    isGeneralLedgerExpanded(item) {
        const index = this.generalLedgerExpanded.indexOf(item);
        return index !== -1;
    }

    addRemoveGeneralLedgerExpanded(item) {
        const index = this.generalLedgerExpanded.indexOf(item);
        if (index === -1) {
            this.generalLedgerExpanded.push(item);
        } else {
            this.generalLedgerExpanded.splice(index, 1);
        }
    }

    get generalLedgerDisplay() {
        if (this.generalLedgerExpanded.length === this.generalLedger.length) return "generalLedger";
        if (this.generalLedgerExpanded.length === 0) return "balance";
        return "";
    }

    set generalLedgerDisplay(value) {
        if (value === "generalLedger") {
            this.generalLedgerExpanded.splice(0, this.generalLedgerExpanded.length);
            this.generalLedgerExpanded.push(...this.generalLedger);
        } else {
            this.generalLedgerExpanded.splice(0, this.generalLedgerExpanded.length);
        }
    }

    get totalDebit() {
        let total = 0.0;
        // let total2 = 0.0;
        for (const item of this.generalLedger) {
            total += item.totalDebit;
            // for (const at of item.accountingTransactions) {
            //     total2 += at.debit
            // }
        }
        // if (Math.abs(total - total2) > 0.01) {
        //     debugger
        // }
        return total;
    }

    get totalCredit() {
        let total = 0.0;
        // let total2 = 0.0;
        for (const item of this.generalLedger) {
            total += item.totalCredit;
            // for (const at of item.accountingTransactions) {
            //     total2 += at.credit
            // }
        }
        // if (Math.abs(total - total2) > 0.01) {
        //     debugger
        // }
        return total;
    }

    get totalBalance() {
        const diff = this.totalDebit - this.totalCredit;
        if (Math.abs(diff) < 0.005) {
            return 0.0;
        }
        return this.totalDebit - this.totalCredit;
    }

    get total6Debit() {
        let total = 0.0;
        for (const item of this.generalLedger) {
            if (item.name && item.name.startsWith("6")) total += item.totalDebit;
        }
        return total;
    }

    get total6Credit() {
        let total = 0.0;
        for (const item of this.generalLedger) {
            if (item.name && item.name.startsWith("6")) total += item.totalCredit;
        }
        return total;
    }

    get total7Debit() {
        let total = 0.0;
        for (const item of this.generalLedger) {
            if (item.name && item.name.startsWith("7")) total += item.totalDebit;
        }
        return total;
    }

    get total7Credit() {
        let total = 0.0;
        for (const item of this.generalLedger) {
            if (item.name && item.name.startsWith("7")) total += item.totalCredit;
        }
        return total;
    }

    get profitOrLoss() {
        return this.total6Credit + this.total7Credit - (this.total6Debit + this.total7Debit);
    }

    get total401Debit() {
        let total = 0.0;
        for (const item of this.generalLedger) {
            if (item.name.startsWith("401")) total += item.totalDebit;
        }
        return total;
    }

    get total401Credit() {
        let total = 0.0;
        for (const item of this.generalLedger) {
            if (item.name.startsWith("401")) total += item.totalCredit;
        }
        return total;
    }

    get total411Debit() {
        let total = 0.0;
        for (const item of this.generalLedger) {
            if (item.name.startsWith("411")) total += item.totalDebit;
        }
        return total;
    }

    get total411Credit() {
        let total = 0.0;
        for (const item of this.generalLedger) {
            if (item.name.startsWith("411")) total += item.totalCredit;
        }
        return total;
    }

    get total42Debit() {
        let total = 0.0;
        for (const item of this.generalLedger) {
            if (item.name.startsWith("42")) total += item.totalDebit;
        }
        return total;
    }

    get total42Credit() {
        let total = 0.0;
        for (const item of this.generalLedger) {
            if (item.name.startsWith("42")) total += item.totalCredit;
        }
        return total;
    }

    get total512Debit() {
        let total = 0.0;
        for (const item of this.generalLedger) {
            if (item.name.startsWith("512")) total += item.totalDebit;
        }
        return total;
    }

    get total512Credit() {
        let total = 0.0;
        for (const item of this.generalLedger) {
            if (item.name.startsWith("512")) total += item.totalCredit;
        }
        return total;
    }

    mainColor(item) {
        const name = item.name;
        if (name) {
            const values = name.split(" - ");
            return !values.length || !values[0] ? "color:red;" : "";
        }
        return "color:red;";
    }

    mainTitle(item) {
        const name = item.name;
        if (name) {
            const values = name.split(" - ");
            if (values?.length) {
                return item.description ? values[0] + " - " + item.description : values[0];
            }
        }
        return "XXX";
    }

    containsErrors(item) {
        if (item.error) {
            return true;
        }
        for (const accountingTransaction of item.accountingTransactions) {
            if (accountingTransaction.object && accountingTransaction.object.error) {
                return true;
            }
        }
        return false;
    }

    accountingTransactionStyle(accountingTransaction) {
        let style = "";
        if (accountingTransaction && accountingTransaction.object) {
            style = "cursor:pointer;";
            if (accountingTransaction.object.error) {
                style += `background-color: ${colors.red.accent1};`;
            }
        }
        return style;
    }

    openAccountingTransaction(accountingTransaction) {
        if (accountingTransaction.object) {
            if (accountingTransaction.object.type === "document") {
                this.$router.push({
                    name: "document",
                    params: {
                        companyId: this.companyId,
                        id: accountingTransaction.object.id,
                    },
                });
            } else if (accountingTransaction.object.type === "bankTransaction") {
                this.$router.push({
                    name: "reconciliation/bankTransaction",
                    params: {
                        companyId: this.companyId,
                        bankTransactionId: accountingTransaction.object.id,
                    },
                });
            } else if (accountingTransaction.object.type === "reconciliation") {
                this.$router.push({
                    name: "reconciliation",
                    params: {
                        companyId: this.companyId,
                        reconciliationId: accountingTransaction.object.id,
                    },
                });
            } else if (accountingTransaction.object.type === "expenseReport") {
                this.$router.push({
                    name: "expenseReport",
                    params: {
                        companyId: this.companyId,
                        id: accountingTransaction.object.id,
                        //   documentId: document.id
                    },
                });
            } else if (accountingTransaction.object.type === "zTillReceipt") {
                this.$router.push({
                    name: "zTillReceipt",
                    params: {
                        companyId: this.companyId,
                        id: accountingTransaction.object.id,
                        // documentId: document.id
                    },
                });
            }
        }
    }
}

export default toNative(GeneralLedger);
</script>
